import React, { useState } from 'react';
import { FaBookOpen, FaQuoteRight, FaStar, FaTrophy, FaChevronDown } from 'react-icons/fa';
import './Publications.css';
import { professorData } from '../data';

export default function Publications() {
  const { metrics, recentPublications, profiles } = professorData;
  const [activeFilter, setActiveFilter] = useState('All');
  const [expandedId, setExpandedId] = useState(null);

  const filteredPubs = recentPublications.filter(p => {
    if (activeFilter === 'All') return true;
    if (activeFilter === 'Published') return p.status === 'Published' || p.status === 'Online';
    if (activeFilter === 'Under Review') return p.status === 'Under Review';
    return true;
  });

  const toggleAccordion = (index) => {
    setExpandedId(expandedId === index ? null : index);
  };

  return (
    <section id="publications" className="publications section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Scholarly Work</span>
          <h2 className="section-title">Selected Publications</h2>
          <div className="section-rule"></div>
          <p className="section-desc">
            A selection of recent high-impact research articles. 
            View the full list of <strong>{metrics.publications} publications</strong> on my Google Scholar profile.
          </p>
        </div>

        {/* Floating Metrics */}
        <div className="pub__metrics">
          <div className="pub__metric">
            <FaBookOpen />
            <div>
              <div className="pub__metric-val">{metrics.publications}</div>
              <div className="pub__metric-label">Total Publications</div>
            </div>
          </div>
          <div className="pub__metric">
            <FaQuoteRight />
            <div>
              <div className="pub__metric-val">{metrics.citations}</div>
              <div className="pub__metric-label">Total Citations</div>
            </div>
          </div>
          <div className="pub__metric">
            <FaStar />
            <div>
              <div className="pub__metric-val">{metrics.hIndex}</div>
              <div className="pub__metric-label">h-index</div>
            </div>
          </div>
          <div className="pub__metric">
            <FaTrophy />
            <div>
              <div className="pub__metric-val">{metrics.i10Index}</div>
              <div className="pub__metric-label">i10-index</div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="pub__filters">
          <span className="pub__filters-label">Filter by Status:</span>
          <div className="pub__tabs">
            {['All', 'Published', 'Under Review'].map(f => (
              <button 
                key={f}
                className={`pub__tab ${activeFilter === f ? 'pub__tab--active' : ''}`}
                onClick={() => { setActiveFilter(f); setExpandedId(null); }}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* Accordion List */}
        <div className="pub-accordion">
          {filteredPubs.map((p, i) => {
            const isExpanded = expandedId === i;
            let badgeClass = 'pub__badge--blue';
            if (p.status === 'Published' || p.status === 'Online') badgeClass = 'pub__badge--green';
            if (p.status === 'Under Review') badgeClass = 'pub__badge--orange';

            return (
              <div key={i} className={`pub-accordion__item ${isExpanded ? 'expanded' : ''}`}>
                <div 
                  className="pub-accordion__header" 
                  onClick={() => toggleAccordion(i)}
                >
                  <div className="pub-accordion__num">{(i + 1).toString().padStart(2, '0')}</div>
                  <h3 className="pub-accordion__title">{p.title}</h3>
                  <div className="pub-accordion__year-chip">{p.year}</div>
                  <FaChevronDown className="pub-accordion__icon" />
                </div>
                
                <div className="pub-accordion__content" style={{ maxHeight: isExpanded ? '200px' : '0' }}>
                  <div className="pub-accordion__details">
                    <div className="pub-accordion__detail-item">
                      <span className="detail-label">Journal:</span>
                      <span className="detail-value journal-name">{p.journal}</span>
                    </div>
                    <div className="pub-accordion__detail-item">
                      <span className="detail-label">Impact Factor:</span>
                      <span className="detail-value impact-factor">{p.if || 'N/A'}</span>
                    </div>
                    <div className="pub-accordion__detail-item">
                      <span className="detail-label">Status:</span>
                      <span className={`pub__badge ${badgeClass}`}>{p.status}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="pub__footer">
          Want to read more? 
          <a href={profiles.googleScholar} target="_blank" rel="noreferrer">
            Visit my Google Scholar Profile <FaBookOpen style={{fontSize: '0.9rem'}}/>
          </a>
        </div>
      </div>
    </section>
  );
}
